<template>
    <div :class="`pending-actions ${panelSize}`">
        <Panel>
            <component
                v-if="pendingAction"
                :is="pendingAction.type"
                :action="pendingAction"
                @action-handled="handleReloadPendingActions"
            />
            <div class="text-center" v-else>
                <Loader wait-text="Please wait..."/>
            </div>

        </Panel>
    </div>
</template>

<script>
import Panel from "@/components/Panel";
import { setPendingActions, userState } from "@/stores/user";
import { useLoading } from "@/hooks/use-loading";
import { computed, onMounted } from "vue";
import { getPendingActions } from "@/api/login";
import { useRouter } from "vue-router";

import AccountLocked from "@/pages/pending-actions/AccountLocked.vue";
import ForcePasswordReset from "@/pages/pending-actions/ForcePasswordReset.vue";
import Loader from "@/components/Loader.vue";
import ForceMfaSetup from "@/pages/pending-actions/ForceMfaSetup.vue";
import SolveMfa from "@/pages/pending-actions/SolveMfa.vue";
import { applicationState } from "@/stores/application";
import PromptMfaSetup from "@/pages/pending-actions/PromptMfaSetup.vue";

export default {
    name: "PendingActions",
    components: {
        Loader,
        Panel,
        'account_locked': AccountLocked,
        'force_reset_password': ForcePasswordReset,
        'force_mfa_setup': ForceMfaSetup,
        'mfa_code_required': SolveMfa,
        'prompt_mfa_setup': PromptMfaSetup,
    },
    setup() {
        const { isLoading, startLoading, stopLoading } = useLoading(false);

        const router = useRouter();

        const pendingAction = computed(() => userState.pending_actions[0]);

        const panelSize = computed(() => {
            const type = pendingAction.value?.type;
            if (!type || type === 'mfa_code_required') {
                return 'panel-size-small';
            }

            if (type === 'force_reset_password') {
                return 'panel-size-medium';
            }

            return 'panel-size-full';
        });

        const handleReloadPendingActions = async () => {

            startLoading();
            try {
                const { data } = await getPendingActions();

                setPendingActions(data.result);

                if (data.result.length === 0) {
                    if (applicationState.identifier) {
                        window.location.href = `/app/login?appId=${encodeURIComponent(applicationState.identifier)}`;
                    } else {
                        router.push('/');
                    }

                    return;
                }
            } catch (e) {
                console.error(e);
            }

            stopLoading();
        };

        onMounted(() => handleReloadPendingActions());

        return {
            panelSize,
            isLoading,
            pendingAction,
            handleReloadPendingActions
        };
    }
}
</script>

<style scoped lang="scss">
.pending-actions {
    max-width: 90%;
    margin: 100px auto 0 auto;
    padding-bottom: 50px;

    &.panel-size-small {
        max-width: 500px;
    }

    &.panel-size-medium {
        max-width: 900px;
    }
}
</style>